var map = {
	"./Bikini.png": 1419,
	"./Black Dress.png": 1102,
	"./Black Tee.png": 2625,
	"./Bluw Golf Shirt.png": 2009,
	"./Gold Bikini.png": 1535,
	"./Green Golf Shirt.png": 8141,
	"./Grey Tee.png": 8006,
	"./Overalls.png": 217,
	"./Pink Golf Shirt.png": 1047,
	"./Red Dress.png": 1284,
	"./Suit.png": 8285,
	"./White Tee.png": 9065,
	"./Yellow Tee.png": 8617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1126;